import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(theme => ({
  children: {
    cursor: ({ disabled }) => (disabled ? 'default' : 'pointer')
  },
  anchor: {
    cursor: ({ disabled }) => (disabled ? 'default' : 'pointer'),
    display: 'flex',
    alignItems: 'center'
  },

  menu: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    border: '1px solid #E6EAEC',
    borderRadius: '6px',
    boxSizing: 'border-box',
    boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.04)',
    minWidth: '10rem',
    padding: '10px 13px',
    background: '#FFFFFF',
    maxHeight: 350,
    overflow: 'hidden auto',
    justifyContent: 'initial',

    '& .MuiCheckbox-colorSecondary.Mui-checked': {
      color: 'rgb(19, 151, 220, 0.8)'
    },
    '@media (max-width: 575px)': {
      maxHeight: 250
    }
  },

  input: {
    border: 'none',
    outline: 'none',
    color: '#323436'
  },

  loading: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: '0.75rem',
    width: '100%',

    '& > div': {
      marginTop: '1rem',
      marginBottom: '1rem',
      width: '20px !important',
      height: '20px !important'
    }
  }
}))

export default useStyles
